import { cn } from '@/lib/ui/style-helpers'

import { Empty } from '@/components/lemmala-design-system/empty/empty'

import { TimelineItem, TimelineItemProps } from './timeline-item'

export type TimelineProps = {
  items: TimelineItemProps[]
  className?: string
  emptyState?: React.ReactNode
}

export const Timeline = ({ items, className, emptyState }: TimelineProps) => {
  if (items.length === 0) {
    if (emptyState !== undefined) {
      return emptyState
    }

    return <Empty icon='secondary' title='No timeline activity yet' className='mx-auto my-8' />
  }

  return (
    <div className={cn('relative flex flex-col gap-6', className)}>
      {items.map((item, index) => (
        <TimelineItem key={index} {...item} />
      ))}
    </div>
  )
}
